import Frame from "../../../../Frame/index.js";
import React from "react";
import { Stack, Text } from "@bookingcom/bui-react";
import { useCardCarriersCombinedController } from "./useCardCarriersCombinedController.js";
import { CardAirlineGroup } from "@flights/search-ui";
import styles from "./CardCarriersCombined.module.css";
export const CardCarriersCombined = ({ segments, hideLogos }) => {
    const { carrierLogoCodes, carriersText } = useCardCarriersCombinedController(segments);
    return (React.createElement(React.Fragment, null,
        React.createElement(Stack, { direction: "row", gap: 2 },
            hideLogos ? null : (React.createElement(CardAirlineGroup, { codes: carrierLogoCodes, variant: "inline", className: styles.logo, size: 12 })),
            carrierLogoCodes.length === 1 && (React.createElement(Stack.Item, { grow: true },
                React.createElement(Text, { variant: "small_1", align: "start" }, carriersText)))),
        carrierLogoCodes.length > 1 && (React.createElement(Frame, { direction: "row", wrap: "wrap" },
            React.createElement(Text, { variant: "small_1", align: "start" }, carriersText)))));
};
